import { render, staticRenderFns } from "./groupLeaderPosterior.vue?vue&type=template&id=7ed8dc88&scoped=true"
import script from "./groupLeaderPosterior.vue?vue&type=script&lang=js"
export * from "./groupLeaderPosterior.vue?vue&type=script&lang=js"
import style0 from "./groupLeaderPosterior.vue?vue&type=style&index=0&id=7ed8dc88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed8dc88",
  null
  
)

export default component.exports